import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Activity {
  id: string;
  type: 'planting' | 'watering' | 'fertilizing' | 'harvesting' | 'other';
  title: string;
  description: string;
  date: string;
  photos: string[];
  location?: string;
  cropType?: string;
  points: number;
  voiceNote?: string;
  tags: string[];
  createdAt: string;
  updatedAt: string;
}

interface ActivityStore {
  activities: Activity[];
  selectedActivity: Activity | null;
  addActivity: (activity: Activity) => void;
  updateActivity: (id: string, data: Partial<Activity>) => void;
  deleteActivity: (id: string) => void;
  setSelectedActivity: (activity: Activity | null) => void;
  clearActivities: () => void;
}

export const useActivityStore = create<ActivityStore>()(
  persist(
    (set) => ({
      activities: [],
      selectedActivity: null,

      addActivity: (activity) =>
        set((state) => ({
          activities: [activity, ...state.activities],
        })),

      updateActivity: (id, data) =>
        set((state) => ({
          activities: state.activities.map((activity) =>
            activity.id === id ? { ...activity, ...data } : activity
          ),
        })),

      deleteActivity: (id) =>
        set((state) => ({
          activities: state.activities.filter((activity) => activity.id !== id),
          selectedActivity:
            state.selectedActivity?.id === id ? null : state.selectedActivity,
        })),

      setSelectedActivity: (activity) => set({ selectedActivity: activity }),

      clearActivities: () => set({ activities: [], selectedActivity: null }),
    }),
    {
      name: 'activity-storage',
    }
  )
);
